const DECIMAL_PRECISION = {
  AMOUNT: 2,
  PERCENTAGE: 4,
} as const;

const FORM_KEYS = {
  AMOUNT: 'amount',
  PERCENTAGE: 'percentage',
  RELATION: 'buildingRelationId',
  UNIT: 'unitId',
} as const;

const CONSTANTS = {
  DECIMAL_PRECISION,
  FORM_KEYS,
};

export default CONSTANTS;
